module.exports = __webpack_public_path__ + "media/images/donation/megaphones-66c8afc9cee7feeac8cc17396f92d4fe.svg";